import Site666Data from "../../../../src/components/site-666-data.js";
import * as React from 'react';
export default {
  Site666Data,
  React
};